import React, { useState } from 'react';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  // Número de WhatsApp formateado (sin espacios ni guiones para el enlace)
  const phoneNumber = '5493518586216';
  const displayNumber = '+54 9 351 858-6216';

  // Mensaje predeterminado (opcional)
  const defaultMessage = 'Hola! Necesito soporte con Antesala';

  // URL de WhatsApp
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
      }}
    >
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '60px',
          height: '60px',
          backgroundColor: '#25D366',
          borderRadius: '50%',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          transition: 'all 0.3s ease',
          transform: isHovered ? 'scale(1.1)' : 'scale(1)',
          cursor: 'pointer',
          textDecoration: 'none',
        }}
        title={`Contáctanos por WhatsApp: ${displayNumber}`}
      >
        <svg
          width="35"
          height="35"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 0C7.164 0 0 7.164 0 16c0 2.828.74 5.484 2.028 7.78L0 32l8.384-2.196A15.917 15.917 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.236c-2.444 0-4.732-.66-6.696-1.812l-.48-.28-4.98 1.304 1.328-4.856-.308-.5A13.168 13.168 0 012.764 16c0-7.316 5.956-13.272 13.272-13.272 7.316 0 13.272 5.956 13.272 13.272 0 7.316-5.992 13.236-13.308 13.236z"
            fill="white"
          />
          <path
            d="M23.152 19.652c-.392-.196-2.32-1.144-2.68-1.276-.36-.132-.62-.196-.88.196-.26.392-1.008 1.276-1.236 1.536-.228.26-.456.292-.848.096-.392-.196-1.652-.608-3.148-1.94-1.164-1.036-1.948-2.316-2.176-2.708-.228-.392-.024-.604.172-.8.176-.176.392-.456.588-.684.196-.228.26-.392.392-.652.132-.26.066-.488-.034-.684-.1-.196-.88-2.12-1.204-2.904-.316-.764-.636-.66-.88-.672-.228-.012-.488-.012-.748-.012s-.684.096-1.044.488c-.36.392-1.376 1.344-1.376 3.276s1.408 3.8 1.604 4.06c.196.26 2.764 4.22 6.696 5.92.936.404 1.668.644 2.236.824.94.3 1.796.256 2.472.156.756-.112 2.32-.948 2.644-1.864.324-.916.324-1.7.228-1.864-.096-.164-.356-.26-.748-.456z"
            fill="white"
          />
        </svg>
      </a>

      {/* Tooltip opcional */}
      {isHovered && (
        <div
          style={{
            position: 'absolute',
            bottom: '70px',
            right: '0',
            backgroundColor: '#ffffff',
            color: '#333',
            padding: '10px 15px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            whiteSpace: 'nowrap',
            fontSize: '14px',
            fontWeight: '500',
            animation: 'fadeIn 0.3s ease',
          }}
        >
          ¿Necesitas ayuda?
          <div
            style={{
              position: 'absolute',
              bottom: '-6px',
              right: '20px',
              width: '0',
              height: '0',
              borderLeft: '6px solid transparent',
              borderRight: '6px solid transparent',
              borderTop: '6px solid #ffffff',
            }}
          />
        </div>
      )}

      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(5px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @media (max-width: 768px) {
            /* En móvil, el botón será un poco más pequeño */
          }
        `}
      </style>
    </div>
  );
};

export default WhatsAppButton;
